import React, { Component } from "react";
import moment from "moment";
import {
	Button,
	Card,
	Col,
	Input,
	DatePicker,
	Row,
	Upload,
	message,
} from "antd";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { inject } from "mobx-react";
import claimTypes from "../../../../../configs/claim-types";
import { CUSTOMER_CLAIM } from "../../../../../configs/api-paths";

@inject("context")
class CustomerClaimAdmin extends Component {
	state = {
		policyNumber: 0,
		product: "",
		insurer: "",
		address1: "",
		address2: "",
		city: "",
		postcode: "",
		claimDocumentIds: [],
		lossDate: "",
		type: "",
		description: "",
		fileDescription: "",
	};

	componentDidMount() {
		const { quoteId } = this.props.location;
		this.fetchQuoteDataAndUpdateState(quoteId);
	}

	fetchQuoteDataAndUpdateState = async (quoteId) => {
		const { claimsService } = this.props.context;
		const quoteData = await claimsService.fetchQuoteData(quoteId);
		this.setState({
			policyNumber: quoteData.policyNumber,
			product: quoteData.product,
			insurer: quoteData.insurer,
			address1: quoteData.address1,
			address2: quoteData.address2,
			city: quoteData.city,
			postcode: quoteData.postcode,
		});
	};

	render() {
		const {
			policyNumber,
			product,
			insurer,
			address1,
			address2,
			city,
			postcode,
		} = this.state;
		const { TextArea } = Input;
		const BASE_API_URL = process.env.INSURFORCE_BASE_API_URL;

		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Make a Claim</h1>}>
							<Row>
								<Col xs={10}>
									<p>Policy number</p>
								</Col>
								<Col xs={14}>
									<p>{policyNumber}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Product</p>
								</Col>
								<Col xs={14}>
									<p>{product}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Insurer</p>
								</Col>
								<Col xs={14}>
									<p>{insurer}</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Property Address</p>
								</Col>
								<Col xs={14}>
									<p>
										{address1}
										<br />
										{address2}
										<br />
										{city}
										<br />
										{postcode}
									</p>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Date and time the incident occurred</p>
								</Col>
								<Col xs={14}>
									<DatePicker
										showTime={{
											format: "HH:mm",
											defaultValue: moment("00:00", "HH:mm"),
										}}
										onChange={(date) => this.onChangeLossDate(date)}
									/>
								</Col>
							</Row>
							<Row>
								<Col xs={10}>
									<p>Type of Loss</p>
								</Col>
								<Col xs={14}>
									<select
										onChange={this.onChangeSelected}
										defaultValue={"DEFAULT"}
									>
										<option value="DEFAULT" disabled>
											Choose type of loss
										</option>
										{Object.keys(claimTypes).map((claimType, index) => {
											return (
												<option key={index} value={claimType}>
													{claimType}
												</option>
											);
										})}
									</select>
								</Col>
							</Row>
							<Row>
								<p>
									State fully the cause of the loss or damage and give full
									details of how it occurred, please provide as much detail as
									possible
								</p>
							</Row>
							<Row>
								<TextArea
									rows={4}
									onChange={this.handleDescriptionInputChange}
								/>
							</Row>
							<Row style={{ marginTop: 10 }}>
								<Col xs={10}>
									<p>File description (optional)</p>
								</Col>
								<Col xs={14}>
									<TextArea
										rows={2}
										onChange={this.handleFileDescriptionInputChange}
									/>
								</Col>
							</Row>
							<Row style={{ marginTop: 10 }}>
								<Col xs={10}>
									<p>
										Attach any documentary evidence here (images, pdfs and
										documents only)
									</p>
								</Col>
								<Col xs={6}>
									<Upload
										action={BASE_API_URL + CUSTOMER_CLAIM}
										data={{
											policyNumber: policyNumber,
											description: this.state.fileDescription,
										}}
										onChange={this.handleUploadChange}
										onRemove={this.handleUploadOnRemove}
									>
										<Button
											style={{
												background: "#0AE320",
												borderColor: "#0AE320",
												fontSize: "13px",
												padding: "0 4px",
											}}
										>
											Upload Files
										</Button>
									</Upload>
								</Col>
							</Row>
							<Row>
								<Col xs={22} />
								<Col xs={2}>
									<Button onClick={this.handleSubmitButtonClick}>Submit</Button>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleUploadOnRemove = (file) => {
		const { claimDocumentService } = this.props.context;
		claimDocumentService.deleteClaimDocument(file.response);
	};

	handleFileDescriptionInputChange = (e) => {
		this.setState({
			fileDescription: e.target.value,
		});
	};

	handleDescriptionInputChange = (e) => {
		this.setState({
			description: e.target.value,
		});
	};

	handleUploadChange = (info) => {
		let { file } = info;
		let { claimDocumentIds } = this.state;

		if (file.response && file.status === "done") {
			message.success(`${info.file.name} file uploaded successfully`, 5);
			if (claimDocumentIds.indexOf(file.response) === -1) {
				// prevent duplicates
				claimDocumentIds.push(file.response);
				this.setState({ claimDocumentIds: claimDocumentIds });
			}
		} else if (file.status === "error") {
			message.error(
				`${info.file.name} file upload failed. Error: ${info.file.response.message}`,
				10
			);
		}
	};

	handleSubmitButtonClick = async () => {
		const { claimsService, applicationService } = this.props.context;
		const { quoteId } = this.props.location;
		const { type, description, lossDate } = this.state;
		if (!quoteId) {
			message.error(`Data is not loaded, please go back and reload the claim`);
			return;
		}
		if (type === "") {
			message.error(`Please define type of claim before submitting`);
			return;
		} else if (lossDate === "") {
			message.error(`Please define loss date before submitting`);
			return;
		}
		const { username } = applicationService.userProfile;
		const claim = {
			lossDate: lossDate,
			type: type,
			description: description,
			updatedBy: username,
			quote: {
				id: quoteId,
			},
		};
		const fnol = {
			claim: claim,
			claimDocumentIds: this.state.claimDocumentIds,
		};
		await claimsService.fnol(fnol);
		this.props.history.push("/policies/");
	};

	onChangeLossDate(dateTime) {
		this.setState({
			lossDate: dateTime,
		});
	}

	onChangeSelected = async (e) => {
		this.setState({
			type: e.target.value,
		});
	};
}

export default CustomerClaimAdmin;
